import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState } from 'react';
import './Input.scss';
import { jsxs, jsx } from 'react/jsx-runtime';

function Input(_ref) {
  var id = _ref.id,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    name = _ref.name,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    labelContent = _ref.labelContent,
    _ref$onInput = _ref.onInput,
    onInput = _ref$onInput === void 0 ? null : _ref$onInput,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$inputValue = _ref.inputValue,
    inputValue = _ref$inputValue === void 0 ? '' : _ref$inputValue,
    _ref$isInputActive = _ref.isInputActive,
    isInputActive = _ref$isInputActive === void 0 ? false : _ref$isInputActive,
    _ref$innerRef = _ref.innerRef,
    innerRef = _ref$innerRef === void 0 ? null : _ref$innerRef,
    _ref$maxlength = _ref.maxlength,
    maxlength = _ref$maxlength === void 0 ? 16 : _ref$maxlength,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$emptyInputText = _ref.emptyInputText,
    emptyInputText = _ref$emptyInputText === void 0 ? '' : _ref$emptyInputText;
  var _useState = useState(isInputActive),
    _useState2 = _slicedToArray(_useState, 2),
    isActive = _useState2[0],
    setIsActive = _useState2[1];
  var _useState3 = useState(inputValue),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  function handleTextChange(text) {
    setValue(text);
    if (text !== '') {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }
  return /*#__PURE__*/jsxs("div", {
    className: "dtv-common-c-div",
    children: [/*#__PURE__*/jsx("label", {
      htmlFor: name,
      className: "dtv-common-c-div--label ".concat(isActive ? 'dtv-common-c-div--label-active' : ''),
      children: labelContent
    }), /*#__PURE__*/jsx("input", {
      className: "dtv-common-c-div--input ".concat(isActive ? 'dtv-common-c-div--input-active' : '', " ").concat(value === '' ? 'dtv-common-c-div--input-error' : '', " ").concat(className),
      id: id,
      type: type,
      name: name,
      required: required,
      value: value,
      onChange: function onChange(e) {
        return handleTextChange(e.target.value);
      },
      onInput: onInput,
      ref: innerRef,
      maxLength: maxlength,
      disabled: disabled
    }), value === '' ? /*#__PURE__*/jsx("div", {
      className: "dtv-common-c-div--error-state",
      children: emptyInputText
    }) : '']
  });
}

export { Input as default };
//# sourceMappingURL=Input.js.map
